import { createSlice } from '@reduxjs/toolkit';
import { merge, reduce } from 'lodash';

import { ENTITY_TYPES } from 'src/constants';

const initialState = reduce(
  ENTITY_TYPES,
  (result) => {
    result = merge(
      {
        platform: null,
        loading: false,
      },
    );
    return result;
  },
  {},
);

const slice = createSlice({
  name: 'platform',
  initialState,
  reducers: {
    createPlatformStart(state, { payload }) { },
    createPlatformSuccess(state, { payload }) { },
    createPlatformFailure(state, { payload }) { },
    getPlatformStart(state, { payload }) {
      state.loading = true;
    },
    getPlatformSuccess(state, { payload }) {
      const { response } = payload;
      state.platform = response;
      state.loading = false;
    },
    getPlatformFailure(state, { payload }) { },
    editPlatformStart(state, { payload }) {
      state.loading = true;
    },
    editPlatformSuccess(state, { payload }) {
      const { response } = payload;
      state.loading = false;
      state.platform = response;
    },
    editPlatformFailure(state, { payload }) { },

  },
});

export const { actions } = slice;

export default slice.reducer;
